import { ChangeEvent, useEffect } from "react";
import { Box, MenuItem } from "@mui/material";
import { useContextLogs } from "src/Contexts/Logs/LogsContext";
import { IValuesFilterLogs } from "src/Contexts/Logs/LogsContextTypes";
import { valuesDefaultFilterLogs } from "src/Contexts/Logs/valuesDefaultInputsLogs/valuesDefaultInputsLogs";
import { AppTextField } from "src/Pages/components";
import { ModalFilterCore } from "src/Pages/components/ModalFilterCore/Index";

import { UseGetListActionDistinct } from "../TableProducer/hooks/UseGetListActionDistinct";
import { useHttpTableLogs } from "../TableProducer/hooks/useHttpTableLogs";
import { getActionLabel, getUniqueActions } from "src/Pages/TelasSistemas/Utils/LogsTranslate/LogsTranslate";

export const FilterSidebarLogs = () => {
  const { valuesFilterLogs, setValuesFilterLogs } = useContextLogs();

  const { handleGet } = useHttpTableLogs();

  const { handleGetListActionDistinct, listAction } =
    UseGetListActionDistinct();

  useEffect(() => {
    handleGetListActionDistinct();
  }, []);

  const ClearFilter = async () => {
    setValuesFilterLogs(valuesDefaultFilterLogs);

    await handleGet({
      id_user: "",
      start_data: "",
      end_data: "",
      action: "",
    });
  };

  const FilterSearch = async () => {
    await handleGet({
      start_data: valuesFilterLogs.start_data,
      end_data: valuesFilterLogs.end_data,
      action: valuesFilterLogs.action,
      id_user: valuesFilterLogs.id_user,
    });
  };

  const handleChange =
    (prop: keyof IValuesFilterLogs) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesFilterLogs((prevEvent) => ({
        ...prevEvent,
        [prop]: event.target.value,
      }));
    };

  return (
    <ModalFilterCore FilterClear={ClearFilter} FilterSearch={FilterSearch}>
      <Box
        sx={{
          "& > .MuiAutocomplete-root, & > .MuiTextField-root": {
            flexWrap: "wrap",
            display: "flex",
            marginBottom: "1rem",
          },
        }}
      >
        <AppTextField
          label="ID do usuário"
          sxStyle={{ opacity: "", pointerEvents: "auto", width: "100%" }}
          value={valuesFilterLogs.id_user}
          variant="outlined"
          onChange={handleChange("id_user")}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            alignItems: "center",
          }}
        >
          <AppTextField
            label="Data inicial"
            sxStyle={{ opacity: "", pointerEvents: "auto", width: "45%" }}
            type="date"
            value={valuesFilterLogs.start_data}
            variant="outlined"
            onChange={handleChange("start_data")}
          />
          até
          <AppTextField
            label="Data final"
            sxStyle={{
              opacity: "",
              pointerEvents: "auto",
              width: "45%",
              marginRight: 0,
            }}
            type="date"
            value={valuesFilterLogs.end_data}
            variant="outlined"
            onChange={handleChange("end_data")}
          />
        </Box>

        <AppTextField
          fullWidth
          select
          label="Ação"
          sxStyle={{ opacity: "", pointerEvents: "auto" }}
          value={valuesFilterLogs.action}
          variant="outlined"
          onChange={handleChange("action")}
        >
          <MenuItem value="">Todas</MenuItem>
          {getUniqueActions(
            listAction
            .map((a) => a.label)
            .filter((label): label is string => Boolean(label))
          ).map((action) => (
            <MenuItem key={action} value={action}>
              {getActionLabel(action)}
            </MenuItem>
          ))}
        </AppTextField>
      </Box>
    </ModalFilterCore>
  );
};
